import baseTheme from "@skv/frontend/src/styles/jsvariables-nsw.scss";
import nswVariables from "@skv/frontend/src/styles/nsw-variables.scss";

import { timingFunctions } from "polished";

export const nswTheme = Object.assign({}, baseTheme, nswVariables, {
  timingFnEaseOut: timingFunctions("easeOutCubic"),
});
